import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription, zip } from 'rxjs';
import { Brand } from '../../../../core/models/brand';
import { DashboardReportingQueryTypes, IReportDateRange, ReportDao } from '../../../../core/services/dao/reportDao';
import { DemoConstants } from '../../../../assets/data/demoConstants';

@Component({
  selector: 'traffic-by-source-tile',
  templateUrl: './traffic-by-source-tile.component.html',
  styleUrls: ['traffic-by-source-tile.component.scss']
})
export class TrafficBySourceTileComponent implements OnInit, OnDestroy {
  dateRangeSubscription: Subscription;
  @Input() brand: Brand;
  @Input() timezone: string;
  public currentDateRange: IReportDateRange;
  private subs: any[] = [];
  public loadingData = false;
  public chartType: any = 'Pie';
  public mmChartData: any = { series: [], labels: [] };
  public nMMChartData: any = { series: [], labels: [] };
  // public mmChartOpts: PieChartOptions = {};
  // public nMMChartOpts: PieChartOptions = {};
  // public chartEvents: ChartEvent = {};
  public displayField = 'sessions';
  @Input() public creatives;
  private creativeMap: any;
  private sourceMap: any;
  public selectedCreative = 'All';
  private currentLabels = [];
  private listener;
  @ViewChild('nMMChart', { static: false }) nMMChart: any;
  @ViewChild('mmChart', { static: false }) mmChart: any;
  // chartConfig: any = {type: this.chartType, data: this.mmChartData, options: this.mmChartOpts};

  constructor() {}

  ngOnInit() {
    this.fetchTileData();
  }

  private fetchTileData() {
      let mmRes;
      const nMMRes = DemoConstants.nMMRes;

      switch (this.selectedCreative) {
        case 'TEST1':
          mmRes = DemoConstants.test1mmRes;
          break;
        case 'TEST2':
          mmRes = DemoConstants.test2mmRes;
          break;
        case 'TEST3':
          mmRes = DemoConstants.test3mmRes;
          break;
        case 'TEST4':
          mmRes = DemoConstants.test4mmRes;
          break;
        case 'TEST5':
          mmRes = DemoConstants.test5mmRes;
          break;
        case 'TEST6':
          mmRes = DemoConstants.test6mmRes;
          break;
        default:
          mmRes = DemoConstants.mmRes;
          break;
      }
      this.setChartData(mmRes, true);
      this.setChartData(nMMRes, false);
      this.loadingData = false;
  }

  addLabelEventListeners() {
    ///clear all current listeners first
    this.currentLabels.forEach(el => {
      el.removeEventListener('mouseover', this.handleLabelHover);
      el.removeEventListener('mouseout', this.handleLabelOut);
    });
    /// label does not show tooltip by default. add the show class any time label is hovered.
    let labels = document.getElementsByClassName('source-by-tile-label');
    for (let i = 0; i < labels.length; i++) {
      let el = labels.item(i);
      this.currentLabels.push(el);
      el.addEventListener('mouseover', this.handleLabelHover);
      el.addEventListener('mouseout', this.handleLabelOut);
    }
  }

  handleLabelHover(evt) {
    let tooltip = document.getElementsByClassName('chartist-tooltip').item(0);
    tooltip.classList.add('tooltip-show');
  }

  handleLabelOut(evt) {
    let tooltip = document.getElementsByClassName('chartist-tooltip').item(0);
    tooltip.classList.remove('tooltip-show');
  }

  changeSelectedCreative(evt) {
    this.selectedCreative = evt.value;
    this.fetchTileData();
    setTimeout(() => {
      this.addLabelEventListeners();
    }, 500);
  }

  setChartData(data: any, mm: boolean) {
    let initialSeries = [];
    let series = [];
    let totalSessions = 0;
    //add data to series
    for (let record of data) {
      totalSessions += record.sessionCount;
      initialSeries.push({
        name: record.leadSource,
        meta: `<div class="tooltip-header">${record.leadSource}</div><div>${this.formatSessions(
          record.sessionCount
        )} sessions</div>`,
        value: record.sessionCount
      });
    }

    let other = initialSeries.find(s => s.name === 'other');
    let created = false;

    for (let s of initialSeries) {
      if (s.value / totalSessions < 0.02) {
        if (!other) {
          created = true;
          other = {
            name: 'other',
            meta: `<div class="tooltip-header">${'other'}</div><div>${this.formatSessions(s.value)} sessions</div>`,
            value: s.value
          };
        } else {
          other.value += s.value;
          other.meta = `<div class="tooltip-header">${'other'}</div><div>${this.formatSessions(
            other.value
          )} sessions</div>`;
        }
      } else {
        series.push(s);
      }
    }

    if (created) {
      series.push(other);
    }

    let legendContainer = document.getElementById('source-legend');
    // let opts = {
    //   donut: true,
    //   showLabel: true,
    //   labelPosition: 'inside',
    //   donutWidth: 30,
    //   donutSolid: true,
    //   startAngle: 0,
    //   labelInterpolationFnc: (value, idx) => {
    //     // @ts-ignore
    //     return Math.round((value / totalSessions) * 100) + '%';
    //   },
    //   plugins: [
    //
    //   ]
    // } as PieChartOptions;

    series.sort((a, b) => {
      if (a.name > b.name) {
        return -1;
      } else if (a.name < b.name) {
        return 1;
      } else {
        return 0;
      }
    });
    if (mm) {
      if (this.mmChart) {
        // make sure source that doesnt exist in legend is added to end
        let current = this.mmChart.data.series.map(i => i.name);
        let newSources = series.filter(i => !current.includes(i.name));
        for (let newSource of newSources) {
          let newSourceIdx = newSource ? series.indexOf(newSource) : -1;
          if (newSourceIdx !== -1) {
            let toAdd = series.splice(newSourceIdx, 1);
            series.push(toAdd[0]);
          }
        }
        // this.mmChartOpts = opts;
        this.mmChartData.series = series;
        this.mmChart.update({ type: 'Pie' });
      } else {
        // this.mmChartOpts = opts;
        this.mmChartData.series = series;
      }
      ///remove legend if it exists
      let legend = document.getElementsByClassName('source-legend-el').item(0);
      if (legend) legend.remove();
      ///add new legend
      // this.mmChartOpts.plugins.push(
      //   Legend({
      //     position: legendContainer,
      //     className: 'source-legend-el'
      //   })
      // );
    } else {
      // this.nMMChartOpts = opts;
      this.nMMChartData.series = series;
    }
    // this.chartEvents = {
    //   draw: (data: any) => {
    //     if (data.type === 'label') {
    //       data.element._node.classList.add('source-by-tile-label');
    //     }
    //   }
    // };
  }

  private formatSessions(sess) {
    var parts = sess.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }
  private updateSourceMap(record, map, fromPresto = true): void {
    if (fromPresto) {
      if (!map[record.leadSource]) {
        map[record.leadSource] = {
          sessionCount: record.sessionCount,
          airing_count: record.airing_count
        };
      } else {
        let tmp = map[record.leadSource];
        tmp.sessionCount = tmp.sessionCount += record.sessionCount;
        tmp.airing_count = tmp.airing_count += record.airing_count;
        map[record.leadSource] = tmp;
      }
    } else {
      let records = record as any[];
      for (let record of records) {
        this.updateSourceMap(record, map);
      }
    }
  }

  chartInitialized(chart) {
    this.listener = window.matchMedia('print').addEventListener('change', () => {
      chart.update();
    });
  }

  ngOnDestroy() {
    if (this.listener) {
      window.matchMedia('print').removeEventListener('change', this.listener);
    }
    this.subs.forEach(sub => sub.unsubscribe());
  }
}
